import React from 'react';
import {PktHeader} from "@oslokommune/punkt-react";
import {useUsername} from "../utils/utils";

export default function Header() {
    const username = useUsername()
    return (
        <PktHeader
            serviceName={"Barnehage"}
            fixed={false}
            scrollToHide={false}
            canChangeRepresentation={false}
            showLogOutButton={false}
            user={{name: username}}
            logOut={() => window.location.assign('/auth/logout')}
        />
    )
}
